"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
function Spinner({ className, delay, size }) {
    return (0, jsx_runtime_1.jsx)(antd_1.Spin, { className: className, delay: delay || 500, indicator: (0, jsx_runtime_1.jsx)(icons_1.LoadingOutlined, {}), size: size || 'default' });
}
exports.default = Spinner;
